import script from "./KitPendingNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./KitPendingNotice.vue?vue&type=script&setup=true&lang=js"

import "./KitPendingNotice.vue?vue&type=style&index=0&id=1b3bad6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b3bad6c"]])

export default __exports__